<template>

    <ActionCombo :noClearable="noClearable" :placeholder="placeholder" :skeleton="compSkeleton" :disabled="compDisabled" :rules="rules" v-model="dvalue" :items="items"
       open create route="masterdata.disputes" baseType="dispute"
    ></ActionCombo>

</template>

<script setup>

    // import DisputeCombo from '@controls/combo/Dispute'
    //            <DisputeCombo :model="model" :rules="model.rules.id_dispute" v-model="model.id_dispute"></DisputeCombo>

    const props = defineProps({
        disabled: {
            type: [Boolean]
        },
        rules: {
            type: [Array]
        },
        noClearable: {
            type: [Boolean],
            default: false
        },
        skeleton: {
            type: [Boolean]
        },
        isForSearch: {
            type: [Boolean]
        },
        value: {
            type: [String, Number]
        },
        placeholder: {
            type: [String],
            default: 'Dispuut'
        },
        model: {
            type: [Object]
        }

    })
    
    import ActionCombo from '@controls/combo/ActionCombo'
    import {dispute as list} from '@app/list';
    import {computed} from 'vue'

    const emit = defineEmits(['input'])

    const dvalue = computed({
        get() {
            return props.value
        },
        set: function(v) {
            emit('input', v)
        }	
    })

    const compSkeleton = computed({
        get() {
            if (props.skeleton) {
                return true;
            }
            if (!props.model) {
                return false;
            }
            return props.model.isDataLoading;
        }
    });
    const compDisabled = computed({
        get() {
            if (props.disabled) {
                return true;
            }
            if (!props.model) {
                return false;
            }
            return props.model.disabled;
        }
    });

    const items = computed({
        get() {
            if (!props.isForSearch) {
                return list.listActual(dvalue.value) || []
            }
            return [{id: 'any', name: 'Heeft een dispuut'}, {id: 'none', name: 'Heeft geen dispuut'}, ...list.listActual(dvalue.value)];
            
        },
    })

</script>
